import { BusinessType } from '../../../../data-layer/business/types';
import { UserModel } from '../../../../data-layer/user/types';

export const getRegistrationStatus = (businessType: BusinessType, currentUser?: UserModel) =>
    businessType === BusinessType.BLOGGER
        ? currentUser?.bloggerRegistrationStatus
        : currentUser?.businessRegistrationStatus;
